import('../src/javascripts/attachments-redesign');
import('../src/javascripts/navigation');
import("../src/javascripts/tabs");
import('../src/javascripts/slider_splide');
import('../src/javascripts/cards-with-tooltip');
